export function formatBytes(sizeInBytes: number): string {
  if (sizeInBytes < 1024) {
    return `${formatDecimal(sizeInBytes)} Bytes`;
  }
  if (sizeInBytes < 1024 * 1024) {
    return `${formatDecimal(sizeInBytes / 1024)} KB`;
  }
  if (sizeInBytes < 1024 * 1024 * 1024) {
    return `${formatDecimal(sizeInBytes / 1024 / 1024)} MB`;
  }

  return `${formatDecimal(sizeInBytes / 1024 / 1024 / 1024)} GB`;
}

function formatDecimal(num: number) {
  const formatted = num.toFixed(1);
  const [p1, p2] = formatted.split('.');
  if (p2 === '0') {
    return p1;
  } else {
    return `${p1}.${p2}`;
  }
}
